module.exports = __webpack_public_path__ + "img/users.c6f5bbd5.svg";